/** Purchase price rules are defined only for passenger cars. */
export const PURCHASE_PRICE_RULE_VEHICLE_TYPE = 'VEHICLETYPE_PASSENGER_CAR';
